import { createSlice } from "@reduxjs/toolkit";

interface InitialState {
  isEditing: boolean;
}

const initialState: InitialState = {
  isEditing: false,
};

const controlSlice = createSlice({
  name: "control",
  initialState,
  reducers: {
    setIsEditingPersonalInformation: (state, action) => {
      state.isEditing = action.payload;
    },
    resetControl: () => {
      return { ...initialState };
    },
  },
});

export const { setIsEditingPersonalInformation, resetControl } =
  controlSlice.actions;

export default controlSlice.reducer;
